// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Dt-z","giftOrPromoSelector":"Et-z","disabled":"Ft-z","subTitle":"Gt-z","selectShipAddressMessage":"Ht-z","changePayment":"It-z"};